<div class="login-page">
  <div
    class="login-scene"
    aria-hidden="true"
  >
    <canvas #cloudCanvas></canvas>
  </div>
  <header class="login-header">
    <img
      class="login-logo"
      src="assets/reflact-logo.png"
      alt="reflact AG"
      width="172"
      height="36"
    >
    <div class="login-header-tools">
      <button
        type="button"
        class="login-motion"
        (click)="toggleAnimation()"
        [attr.aria-pressed]="animationPaused"
        title="Wolkenflug pausieren"
        aria-label="Wolkenflug pausieren"
        i18n-title="@@loginPauseClouds"
        i18n-aria-label="@@loginPauseClouds"
      >
        <i
          [class]="animationPaused ? 'ri-play-line' : 'ri-pause-line'"
          aria-hidden="true"
        ></i>
      </button>
      <span class="login-header-label">reflact ID</span>
    </div>
  </header>
  <main class="login-main">
    <section
      class="login-content"
      aria-labelledby="login-title"
    >
      <div class="login-eyebrow">
        <span
          class="login-accent"
          aria-hidden="true"
        ></span>
        <span i18n="@@loginWelcome">Willkommen bei reflact</span>
      </div>
      <h1 id="login-title">reflact<span class="login-id"> ID</span><span class="login-period">.</span></h1>
      <p
        class="login-intro"
        *ngIf="state === 'login'"
        i18n="@@loginIntro"
      >Ein Zugang. Alle Möglichkeiten.</p>
      <p
        class="login-intro"
        *ngIf="state === 'mandant'"
        i18n="@@loginChooseOrganization"
      >Ihre Organisation.</p>
      <p
        *ngIf="message"
        class="login-message"
        role="status"
      >{{ message }}</p>
      <div
        class="login-actions"
        *ngIf="state === 'login'"
      >
        <button
          type="button"
          pButton
          class="login-signin"
          (click)="signInWithLogto()"
        >
          <span i18n="@@login-with-logto">Mit reflact-ID anmelden</span>
          <i
            class="ri-arrow-right-line"
            aria-hidden="true"
          ></i>
        </button>
        <span class="login-security">
          <i
            class="ri-lock-2-line"
            aria-hidden="true"
          ></i>
          <span i18n="@@loginSecureAccess">Sicher verbunden.</span>
        </span>
      </div>
      <div
        class="login-organizations"
        *ngIf="state === 'mandant'"
      >
        <button
          type="button"
          class="login-organization"
          (click)="router.navigate(['/admin'])"
          *ngIf="loginService.loggedInUser?.reflactadmin"
        >
          <i
            class="ri-shield-user-line"
            aria-hidden="true"
          ></i>
          <span i18n="@@loginSuperadmin">Superadmin</span>
          <i
            class="ri-arrow-right-line"
            aria-hidden="true"
          ></i>
        </button>
        <button
          type="button"
          class="login-organization"
          *ngFor="let mandant of mandants"
          (click)="selectMandant(mandant)"
        >
          <i
            class="ri-building-line"
            aria-hidden="true"
          ></i>
          <span>{{ mandant.name }}</span>
          <i
            class="ri-arrow-right-line"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </section>
  </main>
  <footer class="login-footer">
    <span class="login-footer-brand">reflact<span aria-hidden="true"> / </span><span
        i18n="@@loginDigitalLearning">Digitales Lernen. Weitergedacht.</span></span>
    <nav
      class="login-legal"
      aria-label="Rechtliches"
      i18n-aria-label="@@loginLegal"
    >
      <a
        href="https://reflact.com/datenschutzerklaerung/"
        target="_blank"
        rel="noopener"
        i18n="@@privacy-policy"
      >Datenschutzerklärung</a>
      <a
        href="https://reflact.com/impressum/"
        target="_blank"
        rel="noopener"
        i18n="@@imprint"
      >Impressum</a>
    </nav>
  </footer>
</div>
